"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  stroke: "#000"
}, _react.default.createElement("path", {
  d: "M11 5C11 7.20914 9.20914 9 7 9C4.79086 9 3 7.20914 3 5M11 5C11 2.79086 9.20914 1 7 1C4.79086 1 3 2.79086 3 5M11 5H13M3 5H1",
  fill: "none",
  strokeWidth: "1.2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

exports.default = _default;